export const environment = {
  production: false,
  backendUrl: 'https://api-staging.splash.tech',
  fsmFrontendUrl: 'https://fsm-staging.splash.tech',
  quizFrontendUrl: 'https://quiz-staging.splash.tech',
  jackpotFrontendUrl: 'https://jackpot-staging.splash.tech',
  hubFrontendUrl: 'https://hub-staging.splash.tech',
  wheelFrontendUrl: 'https://wheel-staging.splash.tech',
  multiWheelGameUrl: 'https://multi-wheel-staging.splash.tech',
  boardGameUrl: 'https://board.splash.tech',
};
